import { FunctionComponent } from 'react';
import DOMPurify from 'dompurify';
import { styled } from 'styled-components';
import { typographyHelper, paletteHelper, spacingHelper } from '@property.com.au/ui-kit';
import { ProptrackLogoBrickSource } from '../ProptrackLogoBrickSource/ProptrackLogoBrickSource';
import { DialogModal } from '../../app-kit/components/DialogModal/DialogModal';

interface VGDisclaimerModalProps {
  opened: boolean;
  onClose: () => void;
  vgDisclaimerHtml: string | null;
}

const DisclaimerContent = styled.div`
  p {
    ${typographyHelper('body01')};
    color: ${paletteHelper('textSecondary')};
  }

  p.state-title {
    ${typographyHelper('body01Bold')};
  }
  h2 {
    display: flex;
    ${typographyHelper('subtitle01')};
    align-items: center;
    gap: ${spacingHelper('extraSmall')};
  }

  ol {
    ${typographyHelper('body01')};
    color: ${paletteHelper('textSecondary')};
    list-style-position: inside;
  }

  a {
    color: ${paletteHelper('textSecondary')};

    &:focus {
      color: ${paletteHelper('textSecondary')};
    }

    &:link {
      color: ${paletteHelper('textSecondary')};
    }
  }
`;

export const VGDisclaimerModal: FunctionComponent<VGDisclaimerModalProps> = ({
  opened,
  onClose,
  vgDisclaimerHtml,
}) => (
  <DialogModal
    opened={opened}
    onClose={onClose}
    primaryButtonText="Got it"
    primaryButtonOnClick={onClose}
    title="Disclaimer"
  >
    <DisclaimerContent>
      <h2>
        Sold data <ProptrackLogoBrickSource />
      </h2>
      <br />
      <p>
        This information is supplied by realestate.com.au (ABN 21 080 195 535) on behalf of
        Proptrack Pty Ltd (ABN 43 127 386 298)
      </p>
      <br />
      {vgDisclaimerHtml && (
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(vgDisclaimerHtml),
          }}
        />
      )}
    </DisclaimerContent>
  </DialogModal>
);
